import React from "react";
import { useLocation } from "react-router-dom";
import { useCurrentFullAccountPage, useIsMobile } from "@hooks";
import { ACCOUNT_SETTINGS, ALL_ASSISTANTS, CAMPAIGN_MANAGER, DATA_PROCESSING, VOICE_OVERVIEW } from "@consts";
import { TopContainer } from "../LayoutWrappers";
import MobileNavigationBar from "../Navigation/MobileNavigationBar";
import CampaignManagerBreadcrumbs from "src/components/widgets/campaign-manager/CampaignManagerBreadcrumbs";
import DataProcessingBreadcrumbs from "src/pages/account/data-processing/DataProcessingBreadcrumbs";

const AccountHeader = (props) => {
  const isMobile = useIsMobile();
  const location = useLocation();
  const page = useCurrentFullAccountPage();
  const isAllAgentsPage = page === ALL_ASSISTANTS;
  const isAccountSettingsPage = page === ACCOUNT_SETTINGS;
  const isVoiceOverviewPage = page === VOICE_OVERVIEW;
  const showCampaignManagerBreadcrumbs = location?.pathname.includes(CAMPAIGN_MANAGER);
  const showDataProcessingBreadcrumbs = location?.pathname.includes(DATA_PROCESSING);
  const showBreadcrumbs = showCampaignManagerBreadcrumbs || showDataProcessingBreadcrumbs;

  if (isAllAgentsPage || isAccountSettingsPage || (isVoiceOverviewPage && !isMobile)) return null;

  return <TopContainer showBreadcrumbs={showBreadcrumbs}>
    {isMobile && <MobileNavigationBar {...props} useCurrentPage={useCurrentFullAccountPage} />}
    {showCampaignManagerBreadcrumbs ? <CampaignManagerBreadcrumbs /> : null}
    {showDataProcessingBreadcrumbs ? <DataProcessingBreadcrumbs /> : null}
  </TopContainer>;
};

export default AccountHeader;
